export const DEFAULT_SPACE_PICTURE = "/images/space-default.webp"
export const DEFAULT_BLOG_PICTURE = "/images/blog-defaultThumbnail.webp"
